import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { AccountWrapperOld } from './Account.style';
import { BetsPanel } from 'src/domains/players/webview/components/Account/accountPanel/AccountPanel';
import { AccountDrawer } from 'src/domains/players/webview/components/Account/accountDrawer/AccountDrawer';
import { RouteViewType } from 'src/domains/layouts/state/router/newRouter/mainRouteTypes';
import { SignUp } from 'src/domains/players/webview/components/SignUp/SignUp';
import { PromoSidebar } from 'src/domains/players/webview/components/Account/promoSidebar/PromoSidebar';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';
import { AppLayoutsState } from 'src/domains/layouts/state/AppLayouts.state';

interface PropsType {
    currentView: RouteViewType | null;
    promotionSlug: string;
    isSignUp: boolean;
    isNotificationsList: boolean;
}

export const AccountSidebar = observer('AccountSidebar', (props: PropsType) => {
    const common = useCommon();
    const appLayoutsState = AppLayoutsState.get(common);
    const config = ConfigComponents.get(common).config;
    const { bannersBoxState } = appLayoutsState;

    if (config.accountDrawerNew) {
        return (
            <AccountWrapperOld topOffset={bannersBoxState.boxHeight}>
                <BetsPanel
                    currentView={props.currentView}
                    isNotificationsList={props.isNotificationsList}
                />
                <PromoSidebar
                    promotionSlug={props.promotionSlug}
                    key='promo-sidebar'
                />
            </AccountWrapperOld>
        );
    }

    return (
        <AccountWrapperOld topOffset={bannersBoxState.boxHeight}>
            <BetsPanel
                currentView={props.currentView}
                isNotificationsList={props.isNotificationsList}
            />
            <AccountDrawer
                promotionSlug={props.promotionSlug}
                currentView={props.currentView}
            />
            {props.isSignUp ? <SignUp /> : null}
        </AccountWrapperOld>
    );
});
